<form class="itinerary-model-content-inner" [formGroup]="accommodationForm">
  <div class="itinerary-model-content">
    <div class="ion-no-padding mb-1">
      <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Hotel Accommodation</ion-title>
    </div>
    <div class="form-container">
      <div formArrayName="data" class="ion-padding-horizontal">
        <div class="single-destination-container" *ngFor="let destination of destinationFormArray().controls; let destIndex = index" [formGroupName]="destIndex">
          <div class="d-flex">
            <p class="destination-name"><b>Destination</b> {{destination.get("destination")?.value}}</p>
            <span *ngIf="destination.errors?.['totalHotelNightsMismatch']" class="error-message">
              Total number of nights across all hotels must be {{ preferredDestinations[destIndex]?.days }}.
            </span>
          </div>         

          <div formArrayName="locations">
            <div class="single-accommodation-container" *ngFor="let accommodation of locationFormArray(destIndex).controls; let locationIndex = index" [formGroupName]="locationIndex">
              <div class="row">
                <div class="col-10">
                  <div class="input-container d-flex align-items-center">
                    <h2 class="location-title fs-6 me-3">Location</h2>
                    <div class="location-input-container"
                      [ngClass]="{ 'invalid-input': accommodation.get('locationName')?.invalid && accommodation.get('locationName')?.touched }">
                      <app-locations-autocomplete formControlName="locationName"></app-locations-autocomplete>
                    </div>
                    <span *ngIf="destination.errors?.['unequalHotelNightsInLocation']" class="error-message">
                      All hotels in each location must have the same number of nights.
                    </span>
                  </div>
                </div>
                <div class="col-2">
                  <div class="d-flex justify-content-end align-items-start">
                    <div class="w-100 d-flex justify-content-end">
                        <button type="button" class="add-more-btn" *ngIf="locationFormArray(destIndex).length !== 1" (click)="removeLocation(destIndex, locationIndex)">x Remove Location</button>
                      </div>
                  </div>
                </div>
              </div>

              <ng-container formArrayName="hotels">            
                <ng-container *ngFor="let hotel of hotelsFormArray(destIndex, locationIndex).controls; let hotelIndex = index" [formGroupName]="hotelIndex">
                  <div class="row align-items-start">
                    <div class="col-4" style="width: 254px;">
                      <div class="input-container">
                        <label for="hotelName" class="label">Hotel Name*</label>
                        <div [ngClass]="{ 'invalid-input': hotel.get('hotelName')?.invalid && hotel.get('hotelName')?.touched }"> 
                          <app-hotel-auto-complete [locationvalue]="accommodation.get('locationName')?.value"
                          formControlName="hotelName"
                          (predictionSelected)="gettingPopulatedHotelvalues($event, destIndex, locationIndex, hotelIndex)"></app-hotel-auto-complete>
                        </div>
                      </div>
                    </div>

                    <div class="col-2 date-time-width">
                      <div class="input-container">
                        <label for="" class="label">Hotel Category*</label>
                        <div
                          [ngClass]="{ 'invalid-input': hotel.get('hotelType')?.invalid && hotel.get('hotelType')?.touched }">
                          <select class="input" formControlName="hotelType">
                            <option value="" hidden>select</option>
                            <option *ngFor="let item of accommodationType" [ngValue]="item.name">{{item.name}}</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div class="col-2 date-time-width">
                      <div class="input-container">
                        <label for="" class="label">Room Category</label>
                        <div
                          [ngClass]="{ 'invalid-input': hotel.get('roomCategory')?.invalid && hotel.get('roomCategory')?.touched }">
                          <app-dropdown-select [dropdownValues]="roomCategory"
                            formControlName="roomCategory"></app-dropdown-select>
                        </div>
                      </div>
                    </div>

                    <div class="number-input-width">
                      <div class="input-container">
                        <label for="" class="label">Rooms*</label>
                        <div
                          [ngClass]="{ 'invalid-input': hotel.get('noOfRooms')?.invalid && hotel.get('noOfRooms')?.touched }">
                          <app-increment-number-input formControlName="noOfRooms"></app-increment-number-input>
                        </div>
                      </div>
                    </div>

                    <div class="number-input-width">
                      <div class="input-container">
                        <label for="" class="label">Nights*</label>
                        <div
                          [ngClass]="{ 'invalid-input': hotel.get('noOfNights')?.invalid && hotel.get('noOfNights')?.touched }">
                          <app-increment-number-input formControlName="noOfNights"></app-increment-number-input>
                        </div>
                      </div>
                    </div>

                    <div class="col">
                      <div class="w-100 d-flex justify-content-end">
                        <button type="button" class="add-more-btn" (click)="removeHotel(destIndex ,locationIndex, hotelIndex)"
                          *ngIf="hotelsFormArray(destIndex, locationIndex).length !== 1">x Remove Hotel</button>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-2 date-time-width">
                      <div class="input-container">
                        <label for="" class="label">Check-in Date*</label>
                        <div
                          [ngClass]="{ 'invalid-input': hotel.get('checkIn')?.invalid && hotel.get('checkIn')?.touched }">
                          <app-date-picker [minDate]="convertToDate(tripStartDate)" [maxDate]="convertToDate(tripEndDate)"
                            formControlName="checkIn"></app-date-picker>
                        </div>
                      </div>
                    </div>
                    <div class="col-2 date-time-width">
                      <div class="input-container">
                        <div>
                          <label for="" class="label">Check-in Time</label>
                          <app-time-picker formControlName="checkInTime"></app-time-picker>
                        </div>
                      </div>
                    </div>
                    <div class="col-2 date-time-width">
                      <div class="input-container">
                        <label for="" class="label">Check-Out Date*</label>
                        <div
                          [ngClass]="{ 'invalid-input': hotel.get('checkOut')?.invalid && hotel.get('checkOut')?.touched }">
                          <app-date-picker [minDate]="convertToDate(tripStartDate)" [maxDate]="convertToDate(tripEndDate)"
                            formControlName="checkOut"></app-date-picker>
                        </div>
                      </div>
                    </div>
                    <div class="col-2 date-time-width">
                      <div class="input-container">
                        <div>
                          <label for="" class="label">Check-out Time</label>
                          <app-time-picker formControlName="checkOutTime"></app-time-picker>
                        </div>
                      </div>
                    </div>
                    <div class="col">
                      <div class="input-container">
                        <label for="" class="label">Meal Plan</label>
                        <div
                          [ngClass]="{ 'invalid-input': hotel.get('mealPlan')?.invalid && hotel.get('mealPlan')?.touched }">
                          <app-meal-plan-input [items]="meals" [selectAllKey]="MEAL_PLAN.ALL_INCLUSION"
                            formControlName="mealPlan"></app-meal-plan-input>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-4">
                      <div class="input-container">
                        <label for="" class="label">Extra Beds/Mattress</label>
                        <div
                          [ngClass]="{ 'invalid-input': hotel.get('extraBeds')?.invalid && hotel.get('extraBeds')?.touched }">
                          <app-increment-number-input formControlName="extraBeds"></app-increment-number-input>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row" *ngIf="!serviceBasedSections.showTourPackage && !serviceBasedSections.showRouteCraft">
                    <div class="col-3">
                      <div class="input-container">
                        <label for="" class="label">Cost / Adult*</label>
                        <div
                          [ngClass]="{ 'invalid-input': hotel.get('costPerAdult')?.invalid && hotel.get('costPerAdult')?.touched }">
                          <app-cost-pricing-input formControlName="costPerAdult" [disableDrowdown]="true"
                            [dropdownArray]="noOfAdutlsDropdown"></app-cost-pricing-input>
                        </div>
                      </div>
                    </div>
                    <div class="col-3">
                      <div class="input-container">
                        <label for="" class="label">Cost / child with bed*</label>
                        <div
                          [ngClass]="{ 'invalid-input': hotel.get('costPerChild')?.invalid && hotel.get('costPerChild')?.touched }">
                          <app-cost-pricing-input formControlName="costPerChild"
                            [dropdownArray]="noOfChildrenDropdown"></app-cost-pricing-input>

                        </div>
                      </div>
                    </div>
                    <div class="col-3">
                      <div class="input-container">
                        <label for="" class="label">Cost / child without bed*</label>
                        <div
                          [ngClass]="{ 'invalid-input': hotel.get('costPerInfant')?.invalid && hotel.get('costPerInfant')?.touched }">
                          <app-cost-pricing-input formControlName="costPerInfant"
                            [dropdownArray]="noOfChildrenDropdown"></app-cost-pricing-input>
                        </div>
                      </div>
                    </div>

                    <div class="col-3">
                      <div class="input-container">
                        <label for="" class="label">Total Accommodation cost*</label>
                        <div
                          [ngClass]="{ 'invalid-input': hotel.get('totalAccommodationCost')?.invalid && hotel.get('totalAccommodationCost')?.touched }">
                          <app-select-text-input [prefix]="'₹'" formControlName="totalAccommodationCost"
                            [readonly]="true"></app-select-text-input>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row justify-content-end">
                    <div class="col">
                      <div class="d-flex justify-content-end align-items-end h-100">
                        <!-- Add hotel for the same location -->
                        <button type="button" class="add-more-btn me-3 mb-1" (click)="addHotelAtLocation(destIndex ,locationIndex, hotelIndex)">+ Hotel</button>
                        <!-- Add hotel at new location -->
                        <button *ngIf="hotelIndex+1 === hotelsFormArray(destIndex, locationIndex).length" type="button" class="add-more-btn mb-1" (click)="addLocationAtDestination(destIndex)">+ Split Stay</button>
                      </div>
                    </div>
                  </div>

                  <div class="dashed-line my-2"></div>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </div>
      </div>

      <!-- Hotel terms and conditons -->
      <div class="ion-no-padding mb-1">
        <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Hotel Terms & Conditions</ion-title>
      </div>
      <div class="ion-padding-horizontal">
        <div class="row">
          <div class="col">
            <div class="input-container">
              <app-selectable-list-items 
                [addButtonText]="'Add Hotel Terms & Conditions'"
                formControlName="hotelTermsAndConditions"
                (setDefaultEmitter)="setDefaultLov($event, 'HotelTermsAndConditions', 'hotelTermsAndConditions')"
                (removeDefaultEmitter)="removeDefaultLov($event, 'HotelTermsAndConditions', 'hotelTermsAndConditions')"
              ></app-selectable-list-items>
            </div>
          </div>
        </div>
      </div>


      <div class="ion-padding-horizontal">
        <div class="row">
          <div class="col">
            <div class="input-container">
              <label for="" class="label">Notes</label>
              <div
                [ngClass]="{ 'invalid-input': accommodationForm.get('sectionNote')?.invalid && accommodationForm.get('sectionNote')?.touched }">
                <app-text-formatting-input formControlName="sectionNote"></app-text-formatting-input>
              </div>
            </div>
          </div>
        </div>
      </div>




    </div>
  </div>

  <div class="ion-padding-horizontal bg-light-gray itinerary-model-footer justify-content-center">
    <ion-button class="unfilled-blue-btn" [disabled]="formDataModified()" (click)="goPrevious()">
      <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="resetForm()" [disabled]="!formDataModified()">
      Reset
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="onSubmit()" [disabled]="!formDataModified()">
      Save
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="saveAndNext()" [disabled]="!formDataModified()">
      Save & Next
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="goNext()" [disabled]="formDataModified()">
      <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
    </ion-button>
  </div>
</form>